<!--
  * Path: packages/frontend/src/features/browser/components/BrowserSecondaryPanel.vue
  * Task: Displays the details of a secondary or preview entity.
  * Update: Removed strict v-if for previews. The full Toolbar is now rendered everywhere, delegating close logic via emit.
-->
<template>
  <SecondaryContextProvider :context-type="contextType">
    <div class="h-100 d-flex flex-column position-relative bg-surface min-w-0 overflow-hidden">
      <!-- Header -->
      <div class="flex-shrink-0 bg-surface z-2 border-b">
        <EntityHeaderMain :is-secondary="true" />
      </div>

      <!-- Scrollable Form Content -->
      <div class="flex-grow-1 overflow-y-auto overflow-x-hidden custom-scrollbar position-relative pa-4 pe-12">
        <BrowserContent />
      </div>

      <!-- Floating Pill Toolbar Overlay (Now fully unified for both contexts) -->
      <ToolbarSidebar
        class="pointer-events-auto"
        :is-secondary="true"
        :hide-close="false"
        @close="handleClose"
      />
    </div>
  </SecondaryContextProvider>
</template>

<script setup lang="ts">
import { useWorkspaceStore } from '@/store/workspace';
import SecondaryContextProvider from './SecondaryContextProvider.vue';
import EntityHeaderMain from '../../../core/components/entityHeader/EntityHeaderMain.vue';
import BrowserContent from './BrowserContent.vue';
import ToolbarSidebar from '@/core/components/common/ToolbarSidebar.vue';

const props = defineProps({
  contextType: { type: String, default: 'secondary' }
});

const workspaceStore = useWorkspaceStore();

const handleClose = () => {
  if (props.contextType === 'preview') {
    workspaceStore.closePreviewEntity();
  } else {
    workspaceStore.closeSecondarySelectedEntity();
  }
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-on-surface), 0.4);
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.z-2 {
  z-index: 2;
}
</style>
